<template></template>

<script setup>
import { onMounted, onUnmounted } from "vue";
import { useInvitations } from "@/composables/useInvitations";

const POLL_INTERVAL = 5 * 60 * 1000;
let intervalId = null;
const { load } = useInvitations();

onMounted(() => {
  load(true);
  intervalId = setInterval(() => {
    if (document.hidden) return;
    load(true);
  }, POLL_INTERVAL);
});

onUnmounted(() => {
  intervalId && clearInterval(intervalId);
});
</script>
